import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './i18n/en/en.json';
import nb from './i18n/nb/nb.json';
import sv from './i18n/sv/sv.json';
import da from './i18n/da/da.json';

const lang = localStorage.getItem('lang');
const basicLanguage = lang || 'en';

const resources = {
  en: { translation: en },
  nb: { translation: nb },
  sv: { translation: sv },
  da: { translation: da },
};

i18n.use(initReactI18next).init({
  resources,
  lng: basicLanguage,
  fallbackLng: ['en', 'nb', 'sv', 'da'],
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
